import {Component, inject, OnInit, ViewChild} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CustomTitle } from 'lib-base';
import { TabViewModule } from 'primeng/tabview';
import { PqrsdfPendienteAsignacionComponent } from './pqrsdf-pendiente-asignacion.component';
import { TramitesPendienteAsignacionComponent } from './tramites-pendiente-asignacion.component';
import {CustomTitleDirective} from "../../../shared/clases/custom-title.directive";

@Component({
  selector: 'app-asignacion-manual',
  standalone: true,
  imports: [TabViewModule, TranslateModule, CustomTitle, PqrsdfPendienteAsignacionComponent, TramitesPendienteAsignacionComponent],
  template: `
  <section class="flex justify-content-center mt-4">
      <div class="card-table col-12 flex flex-column">
          <div>
              <CustomTitle [title]="'msg.asignacionManual' | translate" [showTag]="false"
                          styleClass="font-principal app-title-page-color font-medium font-23 mt-4  text-uppercase mb-0"/>
          </div>
          <p-tabView [(activeIndex)]="activeTabIndex" (activeIndexChange)="activeIndexChange($event)">
              <p-tabPanel>
                  <ng-template pTemplate="header">
                      <div class="flex gap-1 align-items-center">
                          <span>
                              {{'common.tramites' |translate}}
                          </span>
                      </div>
                  </ng-template>
                  <app-tramites-pendiente-asignacion></app-tramites-pendiente-asignacion>
              </p-tabPanel>
              <p-tabPanel>
                  <ng-template pTemplate="header">
                      <div class="flex gap-1 align-items-center">
                          <span>
                              {{'common.pqrsd' |translate}}
                          </span>
                      </div>
                  </ng-template>
                  <app-pqrsdf-pendiente-asignacion></app-pqrsdf-pendiente-asignacion>
              </p-tabPanel>
          </p-tabView>
      </div>
  </section>
  `
})
export class AsignacionManualComponent implements OnInit {
  activeTabIndex: number = 0;

  @ViewChild(PqrsdfPendienteAsignacionComponent) pqrsdfPendienteAsignacionComponent !: PqrsdfPendienteAsignacionComponent;
  @ViewChild(TramitesPendienteAsignacionComponent) tramitesPendienteAsignacionComponent !: TramitesPendienteAsignacionComponent;
  private titleService:CustomTitleDirective = inject(CustomTitleDirective);

  activeIndexChange(index: number) {
    this.activeTabIndex = index;
    if (this.activeTabIndex === 0) {
      this.tramitesPendienteAsignacionComponent.getActividadesPendienteAsignacion();
    }else if (this.activeTabIndex === 1) {
      this.pqrsdfPendienteAsignacionComponent.getActividadesPendienteAsignacion();
    }
  }

  ngOnInit(): void {
    this.titleService.changeTitle('msg.asignacionManual');
  }
}
